// Themed metatemplates for InputType 'ObjectEditor' (pict-section-form's ObjectEditor input, which
// embeds pict-section-objecteditor as an interactive JSON tree). Mirrors InputType-Picker.js's Bulma
// chrome (column / field / label / help) so the editor inherits Headlight's form styling instead of the
// minimal base template, whose bare "<span>Name:</span>" sat inline-left of the tree inside the flex
// .columns row. The control is the host div the ObjectEditor provider mounts the tree into; the element
// ids + ControlAttr match what Pict-Provider-Input-ObjectEditor expects (DISPLAY-FOR-<RawHTMLID>).
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME — interactive tree for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
						<div class="field">
							<div class="control">
								<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor"></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME — locked/read-only. The same tree renders non-editable (Editable:false via PictForm.ReadOnly). */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor (read) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input type="hidden" tabindex="-1" {~D:Record.Macro.InputFullProperties~} value="">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor pict-section-form-objecteditor-readonly"></div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME — non-interactive PDF. Same host; the tree paints read-only. */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObjectEditor',
			DefaultInputExtensions: [ 'Pict-Input-ObjectEditor' ],
			Template: /*HTML*/`
			<!-- InputType ObjectEditor (print) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-objecteditor pict-section-form-objecteditor-readonly"></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
